import type { TAccountState } from '@/types/state-types'
import mockUser from './data'

export default <TAccountState>{
  userId: null,
  accessToken: null,
  expiresIn: null,
  refreshToken: null,
  userRole: null,
  expiringAt: null,
  refreshAttempts: 0,
  profile: mockUser as unknown as TAccountState['profile'],
  profilePromise: null
}
